import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';

export const CHIPS_MIN_500: ChipType[] = [
  {
    color: CHIPS_COLORS.BLUE,
    value: 500,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 2e3,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 5e3,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 20e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 50e3,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 100e3,
  },
];

export const CHIPS_MIN_500_v2: ChipType[] = [
  {
    color: CHIPS_COLORS.BLUE,
    value: 500,
  },
  {
    color: CHIPS_COLORS.YELLOW,
    value: 1e3,
  },
  {
    color: CHIPS_COLORS.RED,
    value: 5e3,
  },
  {
    color: CHIPS_COLORS.VIOLET,
    value: 10e3,
  },
  {
    color: CHIPS_COLORS.GREEN,
    value: 50e3,
  },
  {
    color: CHIPS_COLORS.ORANGE,
    value: 100e3,
  },
  {
    color: CHIPS_COLORS.LIGHT_BLUE,
    value: 500e3,
  },
  {
    color: CHIPS_COLORS.SCARLET,
    value: 1e6,
  },
  {
    color: CHIPS_COLORS.PURPLE,
    value: 5e6,
  },
  {
    color: CHIPS_COLORS.LIGHT_GREEN,
    value: 10e6,
  },
];
